import { endpoints } from 'src/utils/axios';
import axiosPublic from './base';
// ----------------------------------------------------------------------

export async function readerRegister(formData: any) {
  const URL = endpoints.public.reader_register;

  const { data } = await axiosPublic.post(URL, formData);

  return data;
}
